const airDropPackages = require("./airDropPackages.js");
const UTILS = require("../libs/utils.js");
const config = require("../config.js");
const vA763 = [{
  name: "Starter",
  icons: 2,
  rarities: [75, 22, 3, 0, 0, 0]
}, {
  name: "Elite",
  icons: 3,
  rarities: [50, 30, 15, 5, 0, 0]
}, {
  name: "Heroic",
  icons: 4,
  rarities: [0, 48, 35, 14, 2.49, 0.5, 0.01]
}];
const vA764 = [{
  name: "Uncommon",
  color: "#b2f252"
}, {
  name: "Rare",
  color: "#2196F3"
}, {
  name: "Epic",
  color: "#E040FB"
}, {
  name: "Legendary",
  color: "#FBC02D"
}, {
  name: "Relic",
  color: "#ed4242"
}, {
  name: "Contraband",
  color: "#292929"
}, {
  name: "Unobtainable",
  color: "#fff53d"
}];
const AirDrop = function (game, p16756, RENDER) {
  this.rarities = [83.5, 15, 1, 0.5];
  this.init = function (p16758, p16759, p16760, p16761, p16762, p16763) {
    this.x = p16759;
    this.y = p16760;
    this.z = p16761;
    this.owner = p16758 ? p16758.sid : null;
    this.scale = 4;
    this.width = 10;
    this.heightS = 10;
    this.length = 10;
    this.claimRadius = 6;
    this.active = true;
    this.canClaim = false;
    this.fallDist = p16762.fall == null ? this.calcFallDist() : p16762.fall;
    this.speed = 0.05;
    this.imitate = null;
    var v13501 = null;
    if (p16756) {
      var vLN02462 = 0;
      if (p16758 && p16758.account && p16758.account.level >= 50) {
        vLN02462 = 2;
      } else if (p16758 && p16758.account && p16758.account.level >= 25) {
        vLN02462 = 1;
      }
      vLN02462 = vA763[vLN02462];
      var v13502 = UTILS.randFloat(0, 100).round(2);
      if (vLN02462.rarities[0] == 0) {
        v13502 = Math.max(v13502, 0.01);
      }
      var v13503;
      var vLN02463 = 0;
      var vLN02464 = 0;
      for (var vLN02465 = 0; vLN02465 < vLN02462.rarities.length; ++vLN02465) {
        v13503 = vLN02462.rarities[vLN02465];
        vLN02464 += v13503;
        if (v13502 <= vLN02464) {
          vLN02463 = vLN02465;
          break;
        }
      }
      var v13504 = UTILS.getRandom(airDropPackages.filter(p16764 => (!game.isCustom || game.isCustom && !p16764.noCustoms) && p16764.rarity == vLN02463 && (p16764.streak == null || game && game.mode && game.mode.disabledStreaks && game.mode.disabledStreaks.indexOf(p16764.streak) == -1)));
      if (UTILS.isNumber(p16763) && airDropPackages[p16763]) {
        v13504 = airDropPackages[p16763];
      }
      this.dropIndex = v13504 ? v13504.index || 0 : 0;
      v13501 = airDropPackages[this.dropIndex];
      if (v13501.imitate) {
        var v13505 = UTILS.getRandom(airDropPackages.filter(p16765 => (!game.isCustom || game.isCustom && !p16765.noCustoms) && !p16765.imitate));
        if (v13505) {
          this.imitate = v13505.index;
        }
      }
    } else {
      this.dropIndex = p16762.dropIndex || 0;
      v13501 = airDropPackages[this.dropIndex];
    }
    this.icon = v13501.icon || 0;
    this.animate = v13501.animate || 0;
    this.name = v13501.name || "Drop";
    this.rarCol = vA764[v13501.rarity || 0].color;
    if (v13501.init) {
      v13501.init(game, p16756, this, p16758);
    }
    this.claimTime = v13501.claimTime || 3250;
    this.sentTo = {};
    if (RENDER) {
      this.bobAnim = 0;
      this.mesh = RENDER.genObj3D(0, 0, 0);
      var vO433 = {
        isMdl: true,
        transparent: true,
        side: 2,
        rgb: !!this.animate,
        rgbS: this.animate ? 0.5 : undefined,
        color: v13501.color,
        vertexColors: true
      };
      this.meshRef = RENDER.loadMesh({
        src: "./adrp_0",
        ...vO433
      }, 0, -1.5, 0, Math.PI / 2, this.scale, this.mesh);
      this.secMat = RENDER.getMat("./adrp_1", vO433);
      RENDER.scene.add(this.mesh);
      this.updateMesh();
    }
  };
  this.updateMesh = function () {
    this.mesh.position.x = this.x;
    this.mesh.position.y = this.y;
    this.mesh.position.z = this.z;
  };
  this.calcFallDist = function () {
    var vLN10006 = 1000;
    var v13506 = game.canSee(this, this.x, this.y - vLN10006, this.z, 0, 0, true, true, true) || 1;
    return v13506 * vLN10006;
  };
  this.claim = function (p16766) {
    if (this.canClaim) {
      this.active = false;
      this.canClaim = false;
      var v13507 = false;
      if (this.mesh) {
        this.mesh.visible = false;
      }
      if (p16756) {
        game.broadcast("rad", this.sid);
        if (p16766) {
          if (p16766.sid != this.owner) {
            v13507 = true;
          }
          game.broadcast("krp", this.owner, v13507 ? p16766.sid : this.owner);
        }
        if (p16766) {
          game.playSound(config.networkSounds.indexOf("adrop_1"), 0.5, this.owner, this.x, this.y, this.z, true);
          if (airDropPackages[this.dropIndex].claim(game, p16756, this, p16766, v13507)) {
            game.challenges.update(game, v13507 ? "sad" : "cad", 1, null, p16766);
            game.incStat(v13507 ? "sad" : "cad", p16766);
          }
        }
      }
    }
  };
  this.readyClaim = function () {
    this.canClaim = true;
    if (this.meshRef) {
      this.meshRef.material = this.secMat;
    }
  };
  this.update = function (delta) {
    if (this.fallDist > 0) {
      var v13508 = Math.min(this.fallDist, this.speed * delta);
      this.fallDist -= v13508;
      this.y -= v13508;
      if (this.fallDist <= 0) {
        this.readyClaim();
      }
    }
    if (p16756 && this.y <= game.map.deathY) {
      this.claim();
      return;
    } else {
      if (this.mesh) {
        this.updateMesh();
        if (this.canClaim) {
          this.mesh.rotation.x = 0;
          this.mesh.rotation.z = 0;
        } else {
          this.bobAnim += delta * 0.001;
          this.mesh.rotation.x = Math.sin(this.bobAnim) * 0.1;
          this.mesh.rotation.z = Math.sin(this.bobAnim) * -0.1;
          this.mesh.rotation.y += delta * 0.001;
        }
      }
      return;
    }
  };
};
module.exports = function (game, p16769, p16770, p16771) {
  this.drops = [];
  var v13509;
  var v13510;
  var vA765 = [];
  var vThis137 = this;
  this.drop = function (p16772, p16773, p16774, p16775, p16776, p16777, p16778) {
    var v13511 = null;
    for (var vLN02466 = 0; vLN02466 < this.drops.length; ++vLN02466) {
      if (!this.drops[vLN02466].active) {
        v13511 = this.drops[vLN02466];
      }
    }
    if (!v13511) {
      v13511 = new AirDrop(game, p16769, p16770);
      this.drops.push(v13511);
      v13511.sid = this.drops.length;
    }
    v13511.init(p16772, p16773, p16774, p16775, p16776, p16778);
    if (p16777 != null) {
      v13511.sid = p16777;
    }
    if (v13511.fallDist <= 0) {
      v13511.readyClaim();
    }
    if (p16771 && v13511.fallDist) {
      p16771.play("adrop_0", 0.15);
    }
  };
  this.cSync = function (p16779) {
    vThis137.drop(null, p16779[2], p16779[3], p16779[4], {
      fall: p16779[1],
      dropIndex: p16779[5]
    }, p16779[0]);
  };
  this.sync = function () {
    if (this.drops.length) {
      for (var vLN02467 = 0; vLN02467 < game.players.list.length; ++vLN02467) {
        v13509 = game.players.list[vLN02467];
        if (v13509.active || v13509.spectating) {
          for (var vLN02468 = 0; vLN02468 < this.drops.length; ++vLN02468) {
            v13510 = this.drops[vLN02468];
            if (v13510.active && !v13510.sentTo[v13509.id]) {
              vA765.length = 0;
              var v13512 = UTILS.isNumber(v13510.imitate) && v13509.sid != v13510.owner;
              vA765.push(v13510.sid, v13510.fallDist, v13510.x.round(2), v13510.y, v13510.z.round(2), v13512 ? v13510.imitate : v13510.dropIndex);
              v13509.send("ad", vA765);
              v13510.sentTo[v13509.id] = 1;
            }
          }
        }
      }
    }
  };
  this.update = function (delta) {
    for (var vLN02469 = 0; vLN02469 < this.drops.length; ++vLN02469) {
      if (this.drops[vLN02469].active) {
        this.drops[vLN02469].update(delta);
      }
    }
  };
  this.removeBySid = function (p16781) {
    for (var vLN02470 = 0; vLN02470 < vThis137.drops.length; ++vLN02470) {
      if (vThis137.drops[vLN02470].sid == p16781) {
        vThis137.remove(vThis137.drops[vLN02470]);
      }
    }
  };
  this.remove = function (p16782) {
    if (p16770 && p16782.mesh) {
      p16770.scene.remove(p16782.mesh);
      p16782.mesh = null;
    }
    p16782.canClaim = false;
    p16782.active = false;
  };
  this.reset = function () {
    for (var vLN02471 = 0; vLN02471 < this.drops.length; ++vLN02471) {
      this.remove(this.drops[vLN02471]);
    }
    this.drops.length = 0;
  };
};